import type { ButtonProps } from '../Button';

import { styled } from 'styled-components';

import { DefaultButtonSC } from '../Button';

export const DefaultRectangleButtonSC = styled(DefaultButtonSC)`
  min-height: 3.75rem;
  padding-top: 1.125rem;
  padding-bottom: 1.125rem;
`;

export type RectangleButtonProps = ButtonProps & {
  topIcon?: React.ReactElement;
};
